import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/partner',
  component: () => import('@views/Partner/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'share',
      name: 'partner.share',
      component: () => import('@/components/Partner/PartnerShare')
    },
  ]
}
